 /*
 * 导入组件 包含下载模板功能
 * @props:
 *
 */
<template>
<div class="upload-box">
  <!-- 上传组件 -->
  <el-upload class="upload-btn" :action=" baseUrl + '' +uploadUrl" :accept="fileType" :showFileList="false" :on-success="uploadSuccess" :before-upload="uploadBefore" :disabled="uploading">
    <el-button type="danger" icon="el-icon-upload2" :loading="uploading">{{uploadText}}</el-button>
  </el-upload>
</div>
</template>

<script>
export default {
  data() {
    return {
      baseUrl: '',  // 上传前缀
      uploading: false,  // 上传中
      uploadStoreList: []
    }
  },
  props: {
    uploadUrl: { // 导入接口地址
      type: String,
      default: ''
    },
    uploadText: { // 导入按钮文字
      type: String,
      default: '点击上传'
    },
    fileType: { // 导入的文件类型 默认是excel文件
      type: String,
      default: 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  },
  methods: {
    // 上传成功的回调
    uploadSuccess(res, file) {
        if(res.code == '0' && res.msg == 'success'){
            this.uploading = false;
            this.$message({
                message: '导入成功！',
                type: 'success'
            });
            this.uploadStoreList = res.result;
            this.$emit('onUploaded', this.uploadStoreList);
        }else{
            this.$message.error(`导入失败 ${res.msg}`);
            this.uploading = false;
        }

    },
    // 上传之前的回调
    uploadBefore(file) {
        this.uploading = true;
    }
  },
  components: {},
  computed: {},
  watch: {},
  mounted() {

  },
  created() {
    if(window.IPConfig.HOST && window.IPConfig.HOST != ''){
      this.baseUrl = `${window.IPConfig.IP}:${window.IPConfig.HOST}`;
    }else{
      this.baseUrl = `${window.IPConfig.IP}`;
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-box {
    display: inline-block;
    .upload-btn {
        display: inline-block;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/newProductApplication/dialog/uploadExcelComp.vue